import { HeaderIconsWrapper } from './header_icons';

export default HeaderIconsWrapper;
